import { Divider, Flex, Grid, GridItem, Heading, Text } from "@chakra-ui/react";
import { translateSubElementString } from "../../../../../../utils";
import NumberField from "../../../../../../components/NumberField/NumberField";
import { Card } from "../../../../../../components/Card";
import * as React from "react";
import { useTranslation } from "react-i18next";

function TotalsSection({ data, scopeThreeTotalCo2Emissions }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "reportsPage.scope1&2.total.totals"
  });

  return (
    <Card boxShadow="xs">
      <Heading size="md" marginBlock="1">
        {t("title")}
      </Heading>
      <Divider marginBlock={5} />
      <Grid templateColumns="repeat(2, 1fr)" gap={2}>
        <GridItem></GridItem>
        <GridItem>
          <Heading marginBlock="1" align="right" size="sm">
            {translateSubElementString("reportsPage.totalEmissions")}
          </Heading>
        </GridItem>
        <GridItem>
          <Flex>
            <Text
              display="flex"
              justifyContent="center"
              alignItems="center"
              fontSize="sm"
              fontWeight="bold">
              {t("locationBased")}
            </Text>
          </Flex>
        </GridItem>
        <GridItem>
          <NumberField value={data.scope1AndScope2LocationBasedTotalCo2Emissions} />
        </GridItem>
        <GridItem>
          <Flex>
            <Text
              display="flex"
              justifyContent="center"
              alignItems="center"
              fontSize="sm"
              fontWeight="bold">
              {t("marketBased")}
            </Text>
          </Flex>
        </GridItem>
        <GridItem>
          <NumberField value={data.scope1AndScope2MarketBasedTotalCo2Emissions} />
        </GridItem>
        <GridItem>
          <Flex>
            <Text
              display="flex"
              justifyContent="center"
              alignItems="center"
              fontSize="sm"
              fontWeight="bold">
              {t("scopeThree")}
            </Text>
          </Flex>
        </GridItem>
        <GridItem>
          <NumberField value={scopeThreeTotalCo2Emissions} />
        </GridItem>
      </Grid>
    </Card>
  )
}

export default TotalsSection;